// table-search.component.ts
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-table-search',
    templateUrl: './table-search.component.html',
    styleUrls: ['./table-search.component.scss'],
})
export class TableSearchComponent {
    @Input() placeholder = 'Search...';
    @Output() searchPressed = new EventEmitter<string>();
    @ViewChild(TemplateRef, { static: true }) templateRef!: TemplateRef<void>;

    searchValue: string;

    emitSearch() {
        this.searchPressed.emit(this.searchValue);
    }

    clearSearch() {
        this.searchValue = '';
        this.searchPressed.emit(this.searchValue);
    }
}
